import React from "react";
import { useLenis } from "../lib/useLenis";
import { SEO } from "../components/SEO";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { HeroTicker } from "../components/HeroTicker";
import { VehicleBanner } from "../components/VehicleBanner";
import { StatsSection } from "../components/StatsSection";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { WhyMotorPro } from "../components/WhyMotorPro";
import { VehicleCarousel } from "../components/VehicleCarousel";
import { SocialBoost } from "../components/SocialBoost";
import { HowItWorks } from "../components/HowItWorks";
import { WhyPublish } from "../components/WhyPublish";
import { DealerProgram } from "../components/DealerProgram";
import { WhyApp } from "../components/WhyApp";
import { LogoSection } from "../components/LogoSection";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { WhatsAppFloatButton } from "../components/WhatsAppFloatButton";

// This is the exact, unmodified public landing page — moved here verbatim so
// App.tsx can act as a router shell without touching any visual output.
export default function LandingPage() {
  useLenis();

  return (
    <div className="App bg-white">
      <SEO />
      <Header />
      <main>
        <Hero />
        <HeroTicker />
        <VehicleBanner />
        <StatsSection />
        <EditorialMarquee />
        <WhyMotorPro />
        <VehicleCarousel />
        <SocialBoost />
        <HowItWorks />
        <WhyPublish />
        <DealerProgram />
        <WhyApp />
        <LogoSection />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}
